import { faker } from "@faker-js/faker";
import type { Meta, StoryObj } from "@storybook/react";

import { fakeBaseUserAvatarProps } from "@/__mocks__/mockBaseTypes";
import type { UpcomingEventCardProps } from "@/ui/components/home/UpcomingEventCard";
import UpcomingEventCard from "@/ui/components/home/UpcomingEventCard";

const StoryMeta: Meta<UpcomingEventCardProps> = {
  title: "Components/Home/Upcoming Event Card",
  component: UpcomingEventCard,
  argTypes: {
    attendees: { control: "object" },
    title: { control: "text" },
    when: { control: "text" },
  },
  args: {
    attendees: faker.helpers.multiple(() => fakeBaseUserAvatarProps(), {
      count: faker.number.int({ max: 6, min: 3 }),
    }),
    title: faker.lorem.words(),
    when: "Tuesday, 4 - 4:50pm",
  },
};

type Story = StoryObj<UpcomingEventCardProps>;

const Primary: Story = {};

export { Primary };
export default StoryMeta;
